import React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Regular,
    SmoothieScrollView,
    YStack,
} from 'smoothie';

interface BaseStepProps {
    title?: string;
    subtitle?: string;
    children: React.ReactNode;
    buttonBottomMargin?: boolean;
    onContinue: () => Promise<void>;
    isContinueDisabled?: boolean;
}

export const BaseStep = ({
    title,
    subtitle,
    onContinue,
    children,
    buttonBottomMargin,
    isContinueDisabled = false,
}: BaseStepProps) => {
    return (
        <SmoothieScrollView
            automaticallyAdjustKeyboardInsets={true}
            keyboardShouldPersistTaps="never"
            containerStyle={{
                justifyContent: 'space-between',
                paddingHorizontal: 8,
                width: '100%',
                maxWidth: 600,
                marginHorizontal: 0,
            }}
        >
            <YStack width="100%">
                {(title != null || subtitle != null) && (
                    <YStack marginBottom={24} gap={8}>
                        {title != null && <H5Regular>{title}</H5Regular>}
                        {subtitle != null && (
                            <BodyMediumRegular color="$gray1000">
                                {subtitle}
                            </BodyMediumRegular>
                        )}
                    </YStack>
                )}
                {children}
            </YStack>
            <YStack
                width="100%"
                marginTop={12}
                marginBottom={buttonBottomMargin ? 36 : undefined}
            >
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Continue"
                    disabled={isContinueDisabled}
                    onPress={onContinue}
                />
            </YStack>
        </SmoothieScrollView>
    );
};
